// Turns a raw video URL into an embeddable player URL + detected type.
export function resolveVideo(sourceType, url) {
  if (!url) return { kind: "none" };

  if (sourceType === "youtube" || /youtube\.com|youtu\.be/.test(url)) {
    const id = extractYouTubeId(url);
    if (id) return { kind: "iframe", src: `https://www.youtube.com/embed/${id}` };
  }

  if (sourceType === "vimeo" || /vimeo\.com/.test(url)) {
    const id = url.match(/vimeo\.com\/(?:video\/)?(\d+)/)?.[1];
    if (id) return { kind: "iframe", src: `https://player.vimeo.com/video/${id}` };
  }

  if (sourceType === "mp4" || /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(url)) {
    return { kind: "video", src: url };
  }

  // Generic external link — offer it as a button instead of embedding.
  return { kind: "link", src: url };
}

function extractYouTubeId(url) {
  const patterns = [
    /youtu\.be\/([\w-]{11})/,
    /youtube\.com\/watch\?v=([\w-]{11})/,
    /youtube\.com\/embed\/([\w-]{11})/,
    /youtube\.com\/shorts\/([\w-]{11})/,
  ];
  for (const p of patterns) {
    const m = url.match(p);
    if (m) return m[1];
  }
  return null;
}

// Cover/poster image for the public "click to play" screen.
export function getPoster(video) {
  if (!video) return null;
  if (video.cover_url) return video.cover_url;
  if (video.source_type === "youtube" || /youtube\.com|youtu\.be/.test(video.url || "")) {
    const id = extractYouTubeId(video.url || "");
    if (id) return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
  }
  return null;
}
